export const formatChipTagList = (tags, isSmallDesktop) => {
  const MAX_TAGS_DISPLAYED = isSmallDesktop ? 3 : 6;

  // number of tags that will need to be displayed in the tooltip
  const extraCount = tags.length - MAX_TAGS_DISPLAYED;

  const viewableList = tags?.slice(0, MAX_TAGS_DISPLAYED);
  const excessList = extraCount > 0 ? tags?.slice(-extraCount) : [];

  const finalList = [...viewableList, { id: 'extra-count', name: `+${extraCount}` }];

  return extraCount > 0 ? [finalList, excessList] : [viewableList, []];
};

export const getSlicedList = (list, count) => {
  const tempList = list?.slice(0, count);
  const extraCount = list?.length - tempList.length;

  return extraCount ? [...tempList, { id: 'extra-count', name: `+${extraCount}` }] : tempList;
};

export const getPageCount = (meta) => {
  if (!meta || !meta?.count || !meta?.limit) {
    return 1;
  }
  return Math.ceil(meta?.count / meta?.limit);
};

export const getCurrentPage = (meta) => {
  if (!meta || !meta?.offset) {
    return 1;
  }
  return Math.ceil(meta?.offset / meta?.limit) + 1;
};



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/helpers.js